module.exports = __webpack_public_path__ + "img/login-icon-outside.fc680010.png";